module.exports = __webpack_public_path__ + "static/scene-4.cfea63e5.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/scene-4.png
// module id = 303
// module chunks = 2